export default class QDPartyDisclosure {
  PartyGuid: string;

  PartyEmail?: string;

  AgreedEarlier: boolean;
}
